module.exports = __webpack_public_path__ + "static/media/book-finder-app.c4af9487.png";